// Español
export default {
    // Research papers page (/research)
    "nav.globe": "Globo",
    "nav.research": "Investigación",
    "rs.title": "Estudios de investigación",
    "rs.sub": "Nueva investigación de finanzas cuantitativas y bancos centrales de arXiv, la Fed, el BCE, el BPI y el NBER. Gratis en la fuente; se actualiza cada 6 horas.",
    "rs.search": "Busca títulos, autores, resúmenes…",
    "rs.allTopics": "Todos los temas",
    "rs.allSources": "Todas las fuentes",
    "rs.allCountries": "Todos los países",
    "rs.count": "{n} estudios",
    "rs.none": "Ningún estudio coincide con estos filtros.",
    "rs.clear": "Borrar filtros",
    "rs.download": "Descargar PDF de {source}",
    "rs.read": "Leer en {source}",
    "rs.onGlobe": "Abrir {country} en el globo",
    "rs.note": "Títulos, autores y resúmenes enlazan a los editores originales; los PDF se abren en sus sitios. Investigación, no asesoramiento financiero.",
    "rs.global": "Global",
    "rs.loadMore": "Cargar más",
    "rs.details": "Detalles",
    "rs.copy": "Copiar enlace",
    "rs.copied": "Enlace copiado",
    "rs.published": "Publicado",
    "panel.research": "Investigación sobre {country}",
    "panel.researchAll": "Toda la investigación →",
    "rt.trading": "Trading y estructura de mercado",
    "rt.portfolio": "Carteras e inversión",
    "rt.risk": "Riesgo",
    "rt.pricing": "Derivados y modelos de valoración",
    "rt.forecasting": "IA y previsiones",
    "rt.crypto": "Cripto y activos digitales",
    "rt.macro": "Economía y bancos centrales",
    "topic.r-trading": "La investigación sobre trading estudia cómo se forman los precios y cómo se ejecutan las órdenes: estrategias, libros de órdenes, liquidez y costes.",
    "topic.r-portfolio": "La investigación sobre carteras estudia cómo combinar inversiones: qué factores explican la rentabilidad, cómo equilibrar riesgo y rentabilidad y cómo invertir para la jubilación.",
    "topic.r-risk": "La investigación sobre riesgo mide lo que puede salir mal: grandes pérdidas, caídas del mercado, quiebras bancarias y cómo protegerse.",
    "topic.r-pricing": "La investigación sobre valoración construye las matemáticas que ponen precio a opciones y otros contratos, y los modelos de volatilidad.",
    "topic.r-forecasting": "La investigación sobre IA y previsiones comprueba si el aprendizaje automático, los modelos de lenguaje y la estadística pueden predecir precios o la economía, y con qué fiabilidad.",
    "topic.r-crypto": "La investigación sobre cripto estudia criptomonedas, stablecoins, blockchains y activos tokenizados: cómo cotizan y qué riesgos tienen.",
    "topic.r-macro": "La investigación económica analiza el crecimiento, la inflación, los tipos de interés y la política de los bancos centrales, que mueven los mercados durante meses y años.",
    'lang.label': 'Idioma',
    'nav.reports': 'Informes',
    'nav.stocks': 'Seguimiento de acciones',
    loading: 'Cargando noticias del mundo…',
    'err.title': 'No se pudo cargar',
    'err.msg': 'Algo salió mal al cargar la aplicación.',
    'err.retry': 'Reintentar',
    atlas: 'Atlas',
    'search.label': 'Buscar países',
    'search.ph': 'Buscar países o códigos…',
    'filter.region': 'Región',
    'filter.allRegions': 'Todas las regiones',
    'filter.window': 'Periodo',
    'filter.topic': 'Tema',
    'filter.all': 'Todo',
    'stage.title': 'Los mercados, ahora',
    legend: 'Leyenda',
    lastUpdate: 'Última actualización',
    pauseRotation: 'Pausar rotación',
    resumeRotation: 'Reanudar rotación',
    hint: 'Arrastra para girar · haz clic en un punto para abrir un país',
    'panel.latest': 'Lo último',
    'quiet.none': 'No hay noticias en este periodo.',
    'quiet.sub': 'Prueba un periodo más amplio (7D o 30D), o sigue este país para tenerlo en tu lista.',
    'footer.about': 'Acerca de',
    'footer.privacy': 'Privacidad',
    'footer.terms': 'Términos',
    follow: '☆ Seguir',
    following: '★ Siguiendo',
    followingGroup: 'Siguiendo',
    explain: 'Explícamelo',
    hideExplain: 'Ocultar explicación',
    share: 'Compartir',
    whyMatter: 'Por qué puede importar',
    disclaimer: 'Contexto educativo, no asesoramiento financiero.',
    readAt: 'Leer la noticia completa en {source}',
    translate: 'Traducir',
    showing: 'Mostrando {n} de {total}',
    loadMore: 'Cargar {n} más',
    loadingShort: 'Cargando…',
    'story.one': '{n} noticia',
    'story.other': '{n} noticias',
    noStories: 'sin noticias',
    justNow: 'Ahora mismo',
    minAgo: 'hace {n} min',
    hAgo: 'hace {n} h',
    dAgo: 'hace {n} d',
    'range.24h': 'últimas 24 horas',
    'range.7d': 'últimos 7 días',
    'range.30d': 'últimos 30 días',
    'range.all': 'todo',
    'cont.Africa': 'África',
    'cont.Asia': 'Asia',
    'cont.Europe': 'Europa',
    'cont.North America': 'América del Norte',
    'cont.Oceania': 'Oceanía',
    'cont.South America': 'América del Sur',
    'cat.markets': 'Mercados',
    'cat.economy': 'Economía',
    'cat.central-banks': 'Bancos centrales',
    'cat.policy': 'Política y geopolítica',
    'cat.companies': 'Empresas',
    today: 'Hoy',
    'today.top': 'El mundo en 60 segundos',
    'today.banks': 'Decisiones de los bancos centrales',
    'today.mine': 'Tus países',
    'today.emptyTop': 'Aún no hay noticias importantes hoy. Vuelve pronto.',
    'today.emptyMine': 'Pulsa ☆ Seguir en cualquier país para fijarlo aquí.',
    'today.note': 'Los titulares enlazan a los medios originales. Solo contexto educativo, no asesoramiento financiero.',
    'today.open': 'Abrir {country}',
    close: 'Cerrar',
    'cal.timeVaries': 'hora variable',
    'cal.yourTime': '{time} en tu hora',
    'cal.in': 'en {t}',
    'cal.today': 'Decisión anunciada hoy',
    'bank.fed': 'Reserva Federal',
    'bank.ecb': 'Banco Central Europeo',
    'bank.boe': 'Banco de Inglaterra',
    'bank.boj': 'Banco de Japón',
    'auth.signIn': 'Entrar',
    'auth.account': 'Cuenta',
    'auth.btnTitle': 'Cuenta gratuita: guarda tus países en todos tus dispositivos',
    'auth.freeTitle': 'Cuenta gratuita',
    'auth.freeSub': "Guarda los países que sigues en todos tus dispositivos. Sin contraseña: te enviamos un código de un solo uso por email.",
    'auth.emailBtn': "Envíame un código de acceso",
    'auth.sending': 'Enviando…',
    'auth.check': 'Revisa tu bandeja de entrada: el enlace caduca en 20 minutos.',
    "auth.codeTitle": "Revisa tu email",
    "auth.codeSent": "Hemos enviado un código de 6 cifras a {email}. Escríbelo aquí:",
    "auth.codeLabel": "Código de acceso",
    "auth.codeBtn": "Entrar",
    "auth.junk": "¿No lo ves? Puede tardar un minuto. Mira también en Spam o Correo no deseado y márcalo como \"No es spam\" para que los próximos lleguen a tu bandeja de entrada.",
    "auth.otherEmail": "Usar otro email",
    'auth.dev': 'Modo de desarrollo (sin servidor de correo):',
    'auth.devLink': 'haz clic aquí para entrar',
    'auth.fine': 'Solo usamos tu correo para que puedas entrar. Consulta el {link}.',
    'auth.privacy': 'aviso de privacidad',
    'auth.yourAccount': 'Tu cuenta',
    'auth.signedInAs': 'Has entrado como {email}',
    'auth.followCount': 'Sigues {n} países, sincronizados en todos tus dispositivos.',
    'auth.signOut': 'Cerrar sesión',
    'auth.delete': 'Eliminar mi cuenta',
    "auth.confirmDelete": "¿Eliminar tu cuenta? Se borrarán tu correo y tus países guardados, y dejarás de recibir correos de NewsNetWide. No se puede deshacer.",
    'auth.deletedTitle': 'Cuenta eliminada',
    "auth.deletedSub": "Tu correo, tus países guardados y tu suscripción por correo se han borrado.",
    'auth.inTitle': 'Has entrado',
    'auth.inSub': 'Bienvenido/a, {email}. Los países que sigues ya están guardados en tu cuenta.',
    'auth.expired': 'Ese enlace ha caducado. Pide uno nuevo abajo.',
    'auth.used': 'Ese enlace ya se ha usado o no es válido. Pide uno nuevo abajo.',
    'share.source': 'Fuente',
    'share.tagline': 'Cada noticia que mueve los mercados, en un solo globo',
    'share.notAdvice': 'Noticias, no asesoramiento financiero',
    'mc.open': 'Abierto',
    'mc.pre': 'Preapertura',
    'mc.post': 'Fuera de horario',
    'mc.night': 'Sesión nocturna',
    'mc.break': 'Pausa de mediodía',
    'mc.closed': 'Cerrado',
    'mc.holiday': 'Festivo',
    'mc.closesIn': 'Cierra en {t}',
    'mc.opensIn': 'Abre en {t}',
    'mc.endsIn': 'Termina en {t}',
    'mc.reopensIn': 'Reabre en {t}',
    'mc.preIn': 'Preapertura en {t}',
    'mc.afterIn': 'Fuera de horario en {t}',
    'mc.nightIn': 'Sesión nocturna en {t}',
    'mc.openCount': '{n} abiertos',
    'mc.all': 'Todos los mercados',
    "mc.title": "Horario de los mercados",
    "side.countries": "Países",
    "side.menu": "Menú",
    "tools.pricingSub": "Los planes y lo que incluye cada uno",
    'mc.noHolidays': 'festivos no incluidos',
    'mc.local': 'hora local',
    'mc.note': 'Horario regular de cada bolsa en su hora local. Los festivos se incluyen para los mercados de EE. UU., Reino Unido, Alemania y Euronext París (2026–27); otras bolsas pueden cerrar en festivos locales. Las sesiones nocturnas son de futuros sobre índices (Tokio OSE, Hong Kong HKFE).',
    'topic.markets': 'Las noticias de mercados tratan de los precios de acciones, bonos, divisas y materias primas: qué compran y venden los inversores, y por qué.',
    'topic.economy': 'Las noticias económicas (crecimiento, empleo, inflación, comercio) influyen en los beneficios de las empresas y en las decisiones de los bancos centrales en los meses siguientes.',
    'topic.central-banks': 'Los bancos centrales fijan los tipos de interés, el precio del dinero, que afecta a préstamos, ahorros, divisas y precios de los activos.',
    'topic.policy': 'Las decisiones de los gobiernos (impuestos, presupuestos, normas comerciales, sanciones, elecciones, conflictos) pueden cambiar costes y riesgos de sectores enteros.',
    'topic.companies': 'Las noticias de empresas (resultados, operaciones, despidos) pueden mover sus acciones y a veces todo su sector.',
    "snap.title": "Resumen para inversores",
    "snap.source": "Últimos datos oficiales anuales · World Bank Open Data. Contexto, no previsión ni asesoramiento.",
    "snap.gdp_growth": "Crecimiento del PIB",
    "snap.inflation": "Inflación",
    "snap.unemployment": "Desempleo",
    "snap.gdp_per_capita": "PIB por persona",
    "snap.current_account": "Cuenta corriente",
    "snap.exports": "Exportaciones",
    "snap.ofGdp": "del PIB",
    "snap.gdp.shrink": "La economía se contrae.",
    "snap.gdp.slow": "Crecimiento lento.",
    "snap.gdp.moderate": "Crecimiento moderado.",
    "snap.gdp.fast": "Crecimiento rápido.",
    "snap.inf.deflation": "Los precios bajan (deflación).",
    "snap.inf.target": "Cerca del ~2 % al que apuntan la mayoría de los bancos centrales.",
    "snap.inf.above": "Por encima de los objetivos habituales de los bancos centrales.",
    "snap.inf.high": "Inflación alta: el dinero pierde valor rápido.",
    "snap.unemp.low": "Bajo: el mercado laboral está ajustado.",
    "snap.unemp.moderate": "Moderado.",
    "snap.unemp.high": "Alto: mucha gente no encuentra trabajo.",
    "snap.gdppc.note": "Producción media por persona: una medida aproximada de la riqueza de un país.",
    "snap.ca.surplus": "Superávit: ingresa del exterior más de lo que gasta.",
    "snap.ca.deficit": "Déficit: gasta en el exterior más de lo que ingresa y depende del dinero extranjero.",
    "snap.exp.very": "Muy dependiente del comercio: sensible a aranceles y a la demanda mundial.",
    "snap.exp.open": "Una economía abierta al comercio.",
    "snap.exp.domestic": "Impulsada sobre todo por su mercado interno.",
    "auth.since": "Miembro desde el {date}",
    "auth.followed": "Países que sigues",
    "auth.noneFollowed": "Ninguno todavía. Pulsa ☆ Seguir en cualquier país para añadirlo aquí.",
    "auth.unfollow": "Dejar de seguir {country}",
    "auth.email": "Correo",
    "auth.prefUpdates": "Novedades de NewsNetWide",
    "auth.prefUpdatesSub": "Nuevas funciones y noticias del sitio",
    "auth.prefNews": "Boletín",
    "auth.prefNewsSub": "Lo más destacado de los mercados",
    "auth.saved": "Guardado.",
    "auth.prefsError": "Los ajustes de correo no están disponibles ahora mismo.",
    "auth.plan": "Plan",
    "auth.seePlans": "Ver planes",
    "auth.manage": "Gestionar suscripción",
    "auth.trialUntil": "prueba gratuita hasta el {date}",
    "auth.renews": "se renueva el {date}",
    "auth.endsOn": "termina el {date}",
    "auth.briefing": "Resumen matinal",
    "auth.briefingOn": "Envíame un resumen cada mañana",
    "auth.briefingSub": "Las noticias principales de los países que sigues y las próximas fechas clave. Puedes cancelarlo cuando quieras.",
    "auth.briefingNone": "Aún no sigues ningún país, así que empieza con las noticias principales del mundo.",
    "auth.briefingCount": "Países en tu resumen: {n}",
    "auth.briefingAt": "Enviarlo a las",
    "auth.briefingTz": "tu hora ({tz})",
    "auth.briefingPreview": "Ver el ejemplo de hoy ↗",
    "panel.page": "Página del país ↗",
    "footer.countries": "Países",
    glossary: {
        'central-bank': ['Banco central', 'La institución que fija los tipos de interés de un país y gestiona su oferta monetaria.', 'Sus decisiones cambian el coste de pedir prestado para todos y mueven bonos, acciones y la divisa.'],
        fed: ['Reserva Federal (Fed)', 'El banco central de Estados Unidos; su comité (FOMC) fija los tipos de interés de EE. UU.', 'Los tipos de EE. UU. influyen en el coste del crédito y en los flujos de inversión de todo el mundo.'],
        ecb: ['Banco Central Europeo (BCE)', 'El banco central de los 20 países que usan el euro.', 'Sus decisiones afectan a hipotecas, préstamos a empresas y al valor del euro.'],
        boe: ['Banco de Inglaterra', 'El banco central del Reino Unido; su Comité de Política Monetaria fija los tipos británicos.', 'Sus decisiones mueven la libra, los bonos británicos y el coste del crédito en el Reino Unido.'],
        boj: ['Banco de Japón', 'El banco central de Japón.', 'Los cambios en sus tipos, muy bajos, pueden mover el yen y los flujos de inversión mundiales.'],
        'interest-rate': ['Tipo de interés', 'El precio de pedir dinero prestado, normalmente un porcentaje anual.', 'Tipos más altos encarecen los préstamos y suelen frenar el gasto; tipos más bajos hacen lo contrario.'],
        'rate-cut': ['Bajada de tipos', 'Un banco central reduce su tipo de interés.', 'Un crédito más barato puede apoyar el gasto y los beneficios, pero también puede indicar preocupación por la economía.'],
        'rate-hike': ['Subida de tipos', 'Un banco central aumenta su tipo de interés.', 'Suele buscar frenar la inflación y encarece el crédito para familias y empresas.'],
        'basis-points': ['Puntos básicos', 'Un punto básico es el 0,01 %; 25 puntos básicos son un cuarto de punto porcentual.', 'Los cambios de tipos se expresan en puntos básicos, así que indican el tamaño del movimiento.'],
        qe: ['Expansión cuantitativa (QE)', 'Un banco central compra (QE) o reduce (QT) grandes cantidades de bonos para influir en los tipos a largo plazo.', 'Cambia la cantidad de dinero que circula por los mercados financieros.'],
        inflation: ['Inflación', 'El ritmo al que suben los precios; suele medirse con el índice de precios al consumo (IPC).', 'Una inflación alta puede llevar a los bancos centrales a mantener tipos altos y reduce el poder de compra.'],
        gdp: ['PIB', 'Producto interior bruto: el valor total de los bienes y servicios que produce una economía.', 'Es la medida más amplia de si una economía crece o se contrae.'],
        recession: ['Recesión', 'Una caída importante y generalizada de la actividad económica, a menudo dos trimestres de PIB en descenso.', 'Las recesiones suelen traer menos beneficios empresariales y más desempleo.'],
        unemployment: ['Desempleo', 'La parte de personas que quieren trabajar pero no tienen empleo; las nóminas cuentan los empleos creados.', 'Los datos de empleo muestran la fuerza de la economía e influyen en los bancos centrales.'],
        pmi: ['PMI', 'Índice de gerentes de compras: encuesta mensual de actividad empresarial. Por encima de 50 indica expansión.', 'Es una de las primeras señales de hacia dónde va la economía.'],
        'trade-deficit': ['Balanza comercial', 'La diferencia entre lo que un país exporta e importa.', 'Los grandes desequilibrios pueden afectar a la divisa y provocar disputas comerciales.'],
        tariff: ['Arancel', 'Un impuesto sobre los bienes importados.', 'Los aranceles encarecen las importaciones y pueden reducir las ventas y beneficios de los exportadores.'],
        sanctions: ['Sanciones', 'Restricciones que un país impone al comercio o las finanzas con otro.', 'Pueden cerrar mercados, alterar cadenas de suministro y mover los precios de las materias primas.'],
        budget: ['Presupuesto y política fiscal', 'Cómo un gobierno recauda, gasta y se endeuda.', 'Grandes déficits o estímulos pueden afectar al crecimiento, a los bonos y a la divisa.'],
        'bond-yield': ['Rentabilidad de los bonos', 'Lo que gana un inversor con un bono; cuando el precio del bono baja, la rentabilidad sube.', 'La rentabilidad de la deuda pública marca el coste básico del crédito en toda la economía.'],
        index: ['Índice bursátil', 'Una cesta de acciones que sigue un mercado, como el S&P 500 (500 grandes empresas de EE. UU.).', 'Los índices resumen en un número cómo va todo un mercado.'],
        'sell-off': ['Venta masiva', 'Un periodo en que muchos inversores venden a la vez y los precios caen rápido.', 'Suele reflejar miedo o malas noticias; no dice nada seguro sobre lo que pasará después.'],
        volatility: ['Volatilidad', 'Cuánto y con qué rapidez suben y bajan los precios.', 'Más volatilidad significa más incertidumbre y oscilaciones mayores, en ambas direcciones.'],
        currency: ['Tipo de cambio', 'El precio de una moneda expresado en otra.', 'Los movimientos de divisas cambian el coste de importar, viajar y el valor de inversiones extranjeras.'],
        oil: ['Precio del petróleo', 'El precio de mercado del crudo; Brent y WTI son las referencias. La OPEP agrupa a países productores.', 'El petróleo influye en los costes de combustible, transporte y producción, y por tanto en la inflación.'],
        gold: ['Oro', 'El oro negociado como materia prima.', 'Muchos inversores lo compran en tiempos inciertos, por eso su precio refleja nerviosismo.'],
        crypto: ['Criptomoneda', 'Activos digitales como el bitcoin, que se negocian 24/7 sin banco central.', 'Sus precios son muy volátiles y reaccionan a la regulación y al apetito por el riesgo.'],
        etf: ['ETF', 'Un fondo que cotiza en bolsa como una acción y normalmente replica un índice.', 'Los ETF son una forma habitual y barata de invertir en todo un mercado.'],
        earnings: ['Resultados', 'El beneficio que una empresa declara en un periodo, a menudo por acción (BPA).', 'Resultados mejores o peores de lo esperado por los analistas suelen mover la cotización.'],
        revenue: ['Ingresos', 'Todo el dinero que una empresa ingresa por vender sus productos o servicios, antes de costes.', 'El crecimiento de los ingresos muestra si aumenta la demanda de sus productos.'],
        guidance: ['Previsiones de la empresa', 'Lo que la propia empresa prevé para sus resultados futuros.', 'Los cambios en las previsiones a menudo importan tanto como los resultados pasados.'],
        ipo: ['Salida a bolsa (OPV)', 'Cuando una empresa vende acciones por primera vez en una bolsa.', 'Permite al público invertir en ella y muestra el apetito por nuevas cotizaciones.'],
        merger: ['Fusiones y adquisiciones', 'Una empresa se une a otra o la compra.', 'Las operaciones pueden cambiar la competencia y suelen mover las acciones de ambas empresas.'],
        buyback: ['Recompra de acciones', 'Una empresa compra sus propias acciones en el mercado.', 'Devuelve dinero a los accionistas y reduce el número de acciones; no garantiza valor.'],
        dividend: ['Dividendo', 'Una parte del beneficio que se reparte a los accionistas.', 'Los cambios en el dividendo indican la confianza de la empresa en su caja.'],
        layoffs: ['Despidos', 'Una empresa reduce su número de empleados.', 'Puede indicar presión de costes o reestructuración, y afecta al mercado laboral.'],
        bankruptcy: ['Quiebra', 'Un proceso legal cuando una empresa no puede pagar sus deudas.', 'Los accionistas suelen perder casi toda su inversión; los acreedores pueden recuperar una parte.'],
    },
    // Calendar (/calendar)
    "nav.calendar": "Calendario",
    "nav.tools": "Herramientas",
    "nav.pricing": "Precios",
    "tools.soon": "PRONTO",
    "tools.briefing": "Resumen matinal",
    "tools.briefingSub": "Las noticias de tus países por email, cada mañana",
    "tools.calculators": "Calculadoras financieras",
    "tools.calculatorsSub": "Interés compuesto, metas de ahorro, comisiones",
    "tools.holdings": "Seguimiento de posiciones",
    "tools.holdingsSub": "Las noticias sobre las empresas que tienes",
    "tools.papers": "Analizador de artículos",
    "tools.papersSub": "Cualquier paper de investigación, explicado en lenguaje claro",
    "tools.montecarlo": "Simulador Monte Carlo",
    "tools.montecarloSub": "Ahorro, trading y estrategias con opciones, con PDF",
    "cal.title": "Calendario económico",
    "cal.sub": "Decisiones de los bancos centrales, datos económicos clave, cierres de mercado y festivos, de fuentes oficiales, en tu zona horaria.",
    "cal.todayLabel": "Hoy",
    "cal.tomorrow": "Mañana",
    "cal.yesterday": "Ayer",
    "cal.allDay": "Todo el día",
    "cal.now": "ahora",
    "cal.inDH": "en {d} d {h} h",
    "cal.inHM": "en {h} h {m} min",
    "cal.inM": "en {m} min",
    "cal.decision": "{bank}: decisión de tipos",
    "cal.closed": "{exchange} cerrada",
    "cal.early": "{exchange} cierra antes",
    "cal.estimated": "fecha estimada",
    "cal.yourTz": "Horas en tu zona horaria ({tz})",
    "cal.type.public_holiday": "Festivos",
    "cal.allCountries": "Todos los países",
    "cal.yourCountries": "Tus países",
    "cal.noFollows": "Sigue países en el globo para filtrarlos aquí.",
    "cal.addToCal": "Añadir al calendario",
    "cal.subscribe": "Suscribirse",
    "cal.subscribeHint": "Copia este enlace en Google Calendar, Calendario de Apple u Outlook («añadir desde URL»). Se actualiza solo.",
    "cal.copied": "Enlace copiado",
    "cal.source": "Fuente oficial",
    "cal.relatedNews": "Noticias de {country}",
    "cal.period": "Periodo: {period}",
    "cal.none": "No hay nada programado con estos filtros.",
    "cal.error": "El calendario no está disponible ahora mismo. Vuelve a intentarlo en un momento.",
    "cal.comingUp": "Próximamente",
    "cal.fullCalendar": "Calendario completo",
    "cal.euroArea": "Zona euro",
    "cal.note": "Las fechas y horas proceden de cada banco central, bolsa y oficina de estadística (enlace en cada evento). Festivos: biblioteca de código abierto «holidays» (MIT). Nunca mostramos previsiones. Noticias y contexto, no asesoramiento financiero.",
    "cal.series.us_cpi": "Precios al consumo EE. UU. (IPC)",
    "cal.series.us_jobs": "Informe de empleo EE. UU.",
    "cal.series.us_ppi": "Precios de producción EE. UU. (IPP)",
    "cal.series.us_jolts": "Vacantes de empleo EE. UU. (JOLTS)",
    "cal.series.us_eci": "Índice de coste laboral EE. UU.",
    "cal.series.us_gdp": "PIB de EE. UU.",
    "cal.series.us_pce": "Ingresos y gasto personal EE. UU. (PCE)",
    "cal.series.us_trade": "Balanza comercial EE. UU.",
    "cal.series.ea_hicp_flash": "Inflación zona euro (avance)",
    "cal.series.ea_hicp": "Inflación zona euro (definitiva)",
    "cal.series.ea_gdp_flash": "PIB zona euro (avance preliminar)",
    "cal.series.ea_gdp": "PIB y empleo zona euro",
    "cal.series.ea_unemployment": "Desempleo zona euro",
    "cal.series.ea_retail": "Ventas minoristas zona euro",
    "cal.series.uk_cpi": "Precios al consumo Reino Unido (IPC)",
    "cal.series.uk_gdp_q": "PIB Reino Unido (trimestral)",
    "cal.series.uk_gdp_m": "PIB Reino Unido (mensual)",
    "cal.series.uk_jobs": "Mercado laboral Reino Unido",
    "cal.series.uk_retail": "Ventas minoristas Reino Unido",
    "cal.series.au_cpi": "Precios al consumo Australia (IPC)",
    "cal.series.au_jobs": "Población activa Australia",
    "cal.series.au_gdp": "PIB de Australia",
    "bank.snb": "Banco Nacional Suizo",
    "bank.boc": "Banco de Canadá",
    "bank.rba": "Banco de la Reserva de Australia",
    "bank.rbnz": "Banco de la Reserva de Nueva Zelanda",
    "bank.riksbank": "Riksbank (Suecia)",
    "bank.norges": "Norges Bank (Noruega)",
    "bank.rbi": "Banco de la Reserva de la India",
    "cal.promise1": "Solo fuentes oficiales",
    "cal.promise2": "Sin previsiones, solo fechas y resultados",
    "cal.promise3": "Calendario gratuito para suscribirse",
    "cal.yourTimeShort": "tu hora",
    "cal.unitD": "días",
    "cal.unitH": "h",
    "cal.unitM": "min",
    "cal.approxNote": "Hora aproximada: el banco no la fija de antemano",
    "cal.then": "Después:",
    "cal.nextDecisions": "Próximas decisiones de tipos",
    "cal.bankCalendars": "Calendarios oficiales de los bancos · cuenta atrás hasta el anuncio",
    "cal.marketsWeek": "Bolsas esta semana",
    "cal.mktAside": "Cierres esta semana: {n} · horas en {tz}",
    "cal.mktNote": "Solo la sesión principal. Los cierres provienen del calendario oficial de festivos de cada bolsa.",
    "cal.exchange": "Bolsa",
    "cal.rightNow": "Ahora mismo",
    "cal.mkt.open": "Abierta",
    "cal.mkt.pre": "Aún no abre",
    "cal.mkt.break": "Pausa de mediodía",
    "cal.mkt.closedToday": "Cerrada hoy",
    "cal.mkt.closed": "Cerrada",
    "cal.mkt.closesAt": "cierra a las {time} (tu hora)",
    "cal.mkt.opensAt": "abre a las {time} (tu hora)",
    "cal.mkt.earlyAt": "Cierra antes, a las {time}",
    "cal.local": "hora local",
    "cal.country": "País",
    "cal.types": "Tipos de evento",
    "cal.group.central_bank": "Bancos centrales",
    "cal.group.data_release": "Datos económicos",
    "cal.group.markets": "Cierres de mercado",
    "cal.group.public_holiday": "Festivos",
    "cal.badge.central_bank": "Decisión de tipos",
    "cal.badge.data_release": "Dato económico",
    "cal.badge.market_closed": "Mercado cerrado",
    "cal.badge.early_close": "Cierre anticipado",
    "cal.badge.public_holiday": "Festivo",
    "cal.closesEarly": "cierre anticipado",
    "cal.noTrading": "sin negociación en todo el día",
    "cal.released": "Publicado",
    "cal.seeFigure": "Ver la cifra oficial",
    "cal.sourceShort": "Fuente",
    "cal.news": "Noticias",
    "cal.openNote": "{exchange} abierta",
    "cal.plusMore": "+{n} más",
    "cal.oneEvent": "1 evento",
    "cal.nEvents": "{n} eventos",
    "cal.oneHoliday": "1 festivo",
    "cal.nHolidays": "{n} festivos",
    "cal.nowLine": "Ahora · {time}",
    "cal.weekendClosed": "Fin de semana: bolsas cerradas.",
    "cal.nothingDay": "Nada programado.",
    "cal.thisWeek": "Esta semana",
    "cal.nextWeekLabel": "Próxima semana",
    "cal.earlier": "Antes esta semana",
    "cal.show": "Mostrar",
    "cal.tryAll": "Prueba con todos los tipos de evento o desactiva «Tus países».",
    "cal.reset": "Restablecer filtros",
    "cal.prevWeek": "Semana anterior",
    "cal.nextWeek": "Semana siguiente",
    "cal.moreWeek": "Mostrar la semana siguiente",
    "cal.subscribeTitle": "Suscribirse a este calendario",
    "cal.feedAddress": "Dirección del calendario",
    "cal.copyLink": "Copiar enlace",
    "cal.subFine": "Gratis, sin cuenta. Sigue los filtros que elegiste. Noticias y contexto, no asesoramiento financiero.",
    "cal.impact": "Impacto",
    "cal.imp.high": "Alto",
    "cal.imp.medium": "Medio",
    "cal.imp.low": "Bajo",
    "cal.impTip.high": "suele mover tipos, divisas y acciones",
    "cal.impTip.medium": "seguido por los mercados, los mueve con menos frecuencia",
    "cal.impTip.low": "contexto: festivos, datos menores",
    "cal.impNote": "Según el tipo de evento, no es una previsión.",
    "cal.impAll": "Todos",
    "cal.impMediumUp": "Medio +",
    "cal.impHighOnly": "Solo alto",
    "cal.nHigh": "{n} de alto impacto",
    "cal.addShort": "Añadir",
};
